/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, May 2020
 *
 *****************************************************************************/


import React from "react";
import cx from "classnames";
import styles from "./SideDrawerToggler.module.css";
import ArrowLeft from "@material-ui/icons/ArrowLeft";
import ArrowRight from "@material-ui/icons/ArrowRight";

// side arrow to close/open side drawer
const SideDrawerToggler = (props) => {
  return (
    <div
      className={cx(
        styles.Toggler,
        props.isSideDrawerVisible
          ? styles.TogglerNotTranslated
          : styles.TogglerTranslated
      )}
      onClick={props.toggleSideDrawer}>
      {props.isSideDrawerVisible ? (
        <ArrowLeft color="inherit" fontSize="inherit" />
      ) : (
        <ArrowRight color="inherit" fontSize="inherit" />
      )}
    </div>
  );
};

export default SideDrawerToggler;
